export const UPLOAD_ASSET = `
	mutation UploadAsset($input: CreateAssetMutationInput!) {
		createAsset(input: $input) {
			asset {
				id
				databaseId
				type
			}
			errors {
				message
				fullMessage
				path
				type
			}
		}
	}
`;

export const REQUEST_ASSET_UPLOAD_URL = `
	mutation RequestAssetUploadUrl($input: CreateAssetMutationInput!) {
		createAsset(input: $input) {
			asset {
				id
				databaseId
				type
				originalFile {
					fileUploadUrl
					fileUploadUrlExpiresAt
					fileUploadStatus
				}
			}
			errors {
				message
				fullMessage
				path
				type
			}
		}
	}
`;

export const COMPLETE_ASSET_UPLOAD = `
	mutation CompleteAssetUpload($input: UpdateAssetMutationInput!) {
		updateAsset(input: $input) {
			asset {
				id
				databaseId
				type
				originalFile {
					fileUrl
					fileUploadStatus
				}
			}
			errors {
				message
				fullMessage
				path
				type
			}
		}
	}
`;

export const MOVE_ASSET = `
	mutation MoveAsset($input: UpdateAssetMutationInput!) {
		updateAsset(input: $input) {
			asset {
				id
				databaseId
				name
				folder {
					databaseId
				}
				owner {
					databaseId
				}
			}
			errors {
				message
				fullMessage
				path
				type
			}
		}
	}
`;

export const RENAME_ASSET = `
	mutation RenameAsset($input: UpdateAssetMutationInput!) {
		updateAsset(input: $input) {
			asset {
				id
				databaseId
				name
			}
			errors {
				message
				fullMessage
				path
				type
			}
		}
	}
`;

export const RENAME_ASSET_REVISION = `
	mutation RenameAssetRevision($input: UpdateAssetRevisionMutationInput!) {
		updateAssetRevision(input: $input) {
			assetRevision {
				id
				databaseId
				name
			}
			errors {
				message
				fullMessage
				path
				type
			}
		}
	}
`;

export const REMOVE_ASSET = `
	mutation RemoveAsset($input: UpdateAssetMutationInput!) {
		updateAsset(input: $input) {
			asset {
				id
				databaseId
				owner {
					databaseId
				}
			}
			errors {
				message
				fullMessage
				path
				type
			}
		}
	}
`;

export const REMOVE_ASSET_REVISION = `
	mutation RemoveAsset($input: UpdateAssetMutationInput!) {
		updateAsset(input: $input) {
			asset {
				id
				databaseId
			}
			errors {
				message
				fullMessage
				path
				type
			}
		}
	}
`;

export const GET_ASSET = `
	query GetAsset($databaseId: String) {
		asset(databaseId: $databaseId) {
		  createdAt
		  databaseId
		  errorProcessing  
		  name
		  originalFileExtension
		  type
		  folder {
		    databaseId
		  }
		  originalFile {
		    fileSize
		  }
		  processedFile {
		    fileSize
		  }
		  previewFile {
		    fileSize
		  }
		  revisions {
		    createdAt
		    databaseId
		    name
		    metadataFile {
		      fileSize
		    }
		    processedFile {
		      fileSize
		    }
		    previewFile {
		      fileSize
		    }      
		  }
		  permissions {
		  	canManage {
		  		value
		  	}
		  }
		}
	}
`;

export const GET_ASSET_BY_REVISION_ID = `
	query GetAssetByRevisionId($databaseId: String) {
		assetRevision(databaseId: $databaseId) {
			databaseId
			asset {
			  createdAt
			  databaseId
			  errorProcessing  
			  name
			  originalFileExtension
			  type
			  folder {
			    databaseId
			  }
			  originalFile {
			    fileSize
			  }
			  processedFile {
			    fileSize
			  }
			  previewFile {
			    fileSize
			  }
			  revisions {
			    createdAt
			    databaseId
			    name
			    metadataFile {
			      fileSize
			    }
			    processedFile {
			      fileSize
			    }
			    previewFile {
			      fileSize
			    }      
			  }
			  permissions {
			  	canManage {
			  		value
			  	}
			  }
			}
		}
	}
`

export const GET_ASSETS_LIST = `
	query GetAssetsList {
	  viewer {
	    assets {
	      nodes {
	        createdAt
	        databaseId
	        errorProcessing  
	        name
	        originalFileExtension
	        type
	        folder {
	          databaseId
	        }
	        originalFile {
	          fileSize
	        }
	        processedFile {
	          fileSize
	        }
	        previewFile {
	          fileSize
	        }
	        revisions {
	          createdAt
	          databaseId
	          name
	          metadataFile {
	            fileSize
	          }
	          processedFile {
	            fileSize
	          }
	          previewFile {
	            fileSize
	          }      
	        }
	      }
	    }
	    organization {
	      name
	      assets {
	        nodes {
	          createdAt
	          databaseId
	          errorProcessing  
	          name
	          originalFileExtension
	          type
	          folder {
	            databaseId
	          }
	          originalFile {
	            fileSize
	          }
	          processedFile {
	            fileSize
	          }
	          previewFile {
	            fileSize
	          }
	          revisions {
	            createdAt
	            databaseId
	            name
	            metadataFile {
	              fileSize
	            }
	            processedFile {
	              fileSize
	            }
	            previewFile {
	              fileSize
	            }      
	          }
		        permissions {
		        	canManage {
		        		value
		        	}
		        }
	        }
	      }   
	    }
	  }
	}
`;

export const CREATE_FOLDER = `
	mutation CreateFolder($input: CreateAssetMutationInput!) {
		createAsset(input: $input) {
			asset {
				id
				databaseId
				name
				folder {
					databaseId
					name
				}
			}
			errors {
				message
				fullMessage
				path
				type
			}
		}
	}
`;

export const GET_ASSET_FOR_DOWNLOAD = `
	query GetAsset($databaseId: String, $loadPreview: Boolean!, $loadProcessed: Boolean!) {
	  asset(databaseId: $databaseId) {
	    id
	    databaseId
	    type
	    name
	    originalFile {
	      fileUrl
	    }
	    previewFile @include(if: $loadPreview) {
	      fileUrl
	    }
	    processedFile @include(if: $loadProcessed) {
	      fileUrl
	    }
	  }
	}
`;

export const GET_ASSET_REVISION_FOR_DOWNLOAD = `
	query GetAssetRevision($databaseId: String, $loadMetadata: Boolean!, $loadPreview: Boolean!, $loadProcessed: Boolean!) {
	  assetRevision(databaseId: $databaseId) {
	    id
	    databaseId
	    asset {
	    	databaseId
	    }
	    metadataFile @include(if: $loadMetadata) {
	      fileUrl
	    }
	    previewFile @include(if: $loadPreview) {
	      fileUrl
	    }
	    processedFile @include(if: $loadProcessed) {
	      fileUrl
	    }
	  }
	}
`;

export const GET_ASSET_ARCHIVE = `
	query GetAssetArchive($databaseId: String) {
	  asset(databaseId: $databaseId) {
	  	id
	  	databaseId
	  	schemaVersion
	  	archive {
	  		fileNames
	  		type
	  	}
	  }
	}
`;